<template>
    <div class="gdpr-data-item">
        <h4 class="gdpr-data-item__title">
            {{ name }}
        </h4>
        <dl class="gdpr-data-item__data">
            <dt v-if="displayWhat" class="gdpr-data-item__data__title">
                What is it?
            </dt>
            <dd v-if="what" class="gdpr-data-item__data__detail">
                <p>{{ what }}</p>
            </dd>
            <dd v-else class="gdpr-data-item__data__detail">
                <slot name="what" />
            </dd>
            <dt v-if="displayHow" class="gdpr-data-item__data__title">
                How do we get it?
            </dt>
            <dd v-if="how" class="gdpr-data-item__data__detail">
                <p>{{ how }}</p>
            </dd>
            <dd v-else class="gdpr-data-item__data__detail">
                <slot name="how" />
            </dd>
            <dt class="gdpr-data-item__data__title">
                Why do we have it?
            </dt>
            <dd v-if="why" class="gdpr-data-item__data__detail">
                <p>{{ why }}</p>
            </dd>
            <dd v-else class="gdpr-data-item__data__detail">
                <slot />
            </dd>
            <dt class="gdpr-data-item__data__title">
                GDPR basis
            </dt>
            <dd class="gdpr-data-item__data__detail">
                {{ basis }}
            </dd>
        </dl>
    </div>
</template>

<script>

export default {

    props: {
        basis: {
            type: String,
            required: true,
        },
        how: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            required: true,
        },
        what: {
            type: String,
            default: null,
        },
        why: {
            type: String,
            default: null,
        },
        showHow: {
            type: Boolean,
            default: false,
        },
        showWhat: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        displayHow() {
            return this.showHow || this.how
        },

        displayWhat() {
            return this.showWhat || this.what
        },
    },
}

</script>

<style lang="scss">

.gdpr-data-item {

    @include element('title') {
        margin-bottom: 0.3rem;
    }

    @include element('data') {
        margin-top: 0;

        @include element('title') {
            font-weight: bold;
        }

        @include element('detail') {
            margin: 0 0 0.3rem 0;
        }
    }
}

</style>
